export const STACK_VARIANTS = {
  drawerContent: {
    gap: '22px',
  },
} as const

export type StackVariant = keyof typeof STACK_VARIANTS

export const StackLayout = {
  variant: (variant?: StackVariant) => (variant ? STACK_VARIANTS[variant] : {}),
} as const
